import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux"
import PropTypes from "prop-types"
import { Row, Col, Button, Input, Tag, Select, message } from "antd"
import axios from "axios"
import isEmail from 'validator/lib/isEmail'

import { pageChanged, startPageLoading, stopPageLoading } from "../../../../data/redux/page_details/actions"
import { getIsMobile } from "../../../../data/redux/page_details/selectors"
import { APP_PAGES, METHOD_TYPES } from "../../../../data/config/constants"
import { log } from "../../../../data/config/utils"

import InputItem from "../../../../components/form/inputitem"
import TextareaItem from "../../../../components/form/textareaitem"

const initialFormState = {
  to: "customercare@vi.com",
  from: "",
  subject: "",
  content: ""
}

const MAX_RETRY_COUNT = 20
const WAITING_TIME = 5000

const trackIdOptions = [
  {
      label: "track1|Bill Explanation|Auto| High Confidence",
      value: "b04fbf35-ad11-4d18-8003-0c29de9bd4c9",
      data: {
          "to": "customercare@vi.com",
          "from": "nklgarg@gmail.com",
          "subject": "regarding high bill for 9167100146 ",
          "content": "Dear Team,�\n\n\nIn my bill DT 4 sept 2021, i noticed i  have been charged extra . Kindly clarify the same asap. I am trying to get clarification on this since last week but i am not getting any response. Kindly let me know the details of these charges asap.�\n\n\nRegards�\nNikhil Garg",
      }
  },
  {
      label: "track2|DND Complaint |Agent Assisted| Deep Negative",
      value: "a9b2487d-fcde-455c-9b39-14f0ff75dfbb",
      data: {
          "to": "customercare@vi.com",
          "from": "priyankamajumder19@yahoo.com",
          "subject": "Request to discontinue promotional sms from VI, Prepaid No. 8981934950.",
          "content": "I am a Prepaid Subscriber of Kolkata Circle, Mobile No. 8981934950.�\n\n\nFrom last 5-6months I am very disturbed by your promotional sms(s) multiple times everyday without any fail. All these sms(s) care sending from VodafoneIdea ltd. about VCare & Recharge offer benifits. I am a technically sound person & don't need such promotional disturbance.�\n\n\nI am registered on FULL DND service from last couple of years, inspite of this you are disturbing me continuously.�\n\n\nI am providing you last 3 working days, after which if the disturbance continues then the matter will be forwarded to Nodal Deptt, Appellate Authority & TRAI for better treatment.�\n\nNever call me in this regards, no verbal communication is needed, all communications must be in written format.� or i will port out\n\n\n\n\n\nSent from Yahoo Mail on Android",
      }
  },
  {
      label: "track3|Sim Block|Auto|High Confidence",
      value: "e63f040c-9895-4400-b8cf-a81ac5e02fae",
      data: {
          "to": "customercare@vi.com",
          "from": "gupta.khushbu@gmail.com",
          "subject": "Block SIM card due to theft",
          "content": "Dear sir,�\n\n\nPlease block my sim card as this has been lost around 9pm today in delhi.\nTrying the customer care number but not able to do it�\nThus is the number 9833125711\n\n\nRegards\nRaju",
      }
  },
  {
      label: "track4|Duplicate Bill|Auto |High Confidence",
      value: "8f370f86-37dc-4db1-99b7-698bfef60a9d",
      data: {
          "to": "customercare@vi.com",
          "from": "anuuj1968@gmail.com",
          "subject": "Request for old bill and receipt statements for specified months",
          "content": "Dear Sir,\nKindly provide the bill and receipt statements for my postpaid number 9968073296 for the months of September to November 2020. I shall be grateful.\n\n\n\n-- \n\nDr Anuj K Bhatnagar, MD, FNCCP\n\n143, Nimri Colony Part 1\nAshok Vihar Phase 4\nDelhi-110052\n\n\n\n-- \n\nDr Anuj K Bhatnagar, MD, FNCCP\n\nConsultant Chest Specialist & Head\nDepartment of Chest & Tuberculosis.\nDirector- DNB Teaching- Respiratory Diseases\nIncharge , DR TB Center\nRajan Babu Institute of Pulmonary Medicine & Tuberculosis\nNorth Delhi Municipal Corporation, Delhi-110009",
      }
  },
  {
      label: "track5|Duplicate Bill|Assisted|Mix Scenarios / Chrun Threatening",
      value: "9987a0ef-b699-4133-858a-c15bb410fe89",
      data: {
          "to": "customercare@vi.com",
          "from": "ramshanker1975.2009@rediffmail.com",
          "subject": "Bill copy",
          "content": "Kindly send bill copy of november and december for my phone no 9811882342. If you did not send a copy of the bill, I will port to some other\ntelecom like jio because  I am requesting to send the bill copy but till date I have received  no bill\nThanks\nRam Shanker\n9811882342",
      }
  },
  {
      label: "track6|bill explanation/dispute|Agent Assisted|Deep Negative",
      value: "4dc600f4-0212-4e07-a32a-79ccdb648775",
      data: {
          "to": "customercare@vi.com",
          "from": "shwetaseth1590@gmail.com",
          "subject": "9873206605 - Unsolicited and uncalled usage charge",
          "content": "This is my second time that vodafone has charged me unecessarily. I have talked to a representative in chat and he promised that the Rs. 20 charge won't come in the bill. But here again vodafone tires to extort the money.\n\n\nPlease don't do it time and again. I am enjoying vodafone but this irritates me. I seriously am very upset frm ur costumer care servies.",
      }
  },
  {
      label: "track7|Network issue|AUTO|High Confidence",
      value: "10213cc5-a344-44b6-a48b-ab475a8c9363",
      data: {
          "to": "customercare@vi.com",
          "from": "sidsllp.acc@gmail.com",
          "subject": "Net connectivity issue for my number 9909024259",
          "content": "Dear sir/mam\nMany time try to call on call center but no response.\nMy mobile number 9909024259 is not working please resolve. my phone shown that i am not registered on network.\nPlease resolve\n\n\nRegards\nJitendra\nTmp number 9268399158",
      }
  },
]

const EmailSendBox = ({
  is_mobile,
  actions
}) => {
  const [formData, setFormData] = useState(initialFormState)
  const [response, setResponse] = useState({})
  const [trackId, setTrackId] = useState(undefined)
  const { pageChanged, startPageLoading, stopPageLoading } = actions
  const timerRef = useRef(null)
  const retryRef = useRef(0)

  useEffect(() => {
    pageChanged(APP_PAGES.EMAIL_SEND_BOX, APP_PAGES.EMAIL_SEND_BOX)
  }, [])

  const handleFormChange = e => {
    const key = e.target.name
    const value = e.target.value
    setFormData(prevState => ({
      ...prevState,
      [key]: value
    }))
  }

  const fetchDataAndProceed = (
    {
      url,
      baseURL = "https://vil-email-dev.oriserve.com",
      method = METHOD_TYPES.GET,
      data = {},
      timeout = 30000
    } = {},
    callback
  ) => {
    axios({
      url,
      baseURL,
      method,
      timeout,
      params: method === METHOD_TYPES.GET ? data : {},
      data: method !== METHOD_TYPES.GET ? data : {},
      headers: { "Content-Type": "application/json" },
      validateStatus: status => ((status >= 200 && status < 300) || status === 412),
    }).then(response => {
      callback(false, response.data)
    }).catch(error => {
      callback(true)
      if (error && error.response) {
        if (error.response.data && error.response.data.message)
          message.error(error.response.data.message)
        else if (error.response.message)
          message.error(error.response.message)
      }
    })
  }

  const fetchTemplate = data => {
    fetchDataAndProceed({
      url: "/getEmailData",
      data
    }, (err, res) => {
      log("fetchTemplate", err, res)
      stopPageLoading()
      if (!err && res && res.data) {
        if (res.data.processingStatus === "queued" && retryRef.current < MAX_RETRY_COUNT) {
          retryRef.current = retryRef.current + 1
          startPageLoading(`Retry attempt${retryRef.current}: Retring template loading`)
          if (timerRef.current)
            clearTimeout(timerRef.current)
          timerRef.current = setTimeout(() => fetchTemplate(data), WAITING_TIME)
        } else {
          retryRef.current = 0
          // clearFormData()
          message.success("Template loaded successfully")
          setResponse({
            responseMode: res.data.responseMode,
            processingStatus: res.data.processingStatus,
            endTemplate: res.data.endTemplate
          })
        }
      } else {
        message.success("Something went wrong")
      }
    })
  }

  const handleSendEmail = () => {
    if (formData.from && formData.subject && formData.content) {
      if (isEmail(formData.from)) {
        startPageLoading("Sending")
        setResponse({})
        const data = {
          ...formData,
          trackId
        }
        fetchDataAndProceed({
          // url: trackId ? "/processEmailCached" : "/processEmail",
          url: "/processEmailCached",
          method: METHOD_TYPES.POST,
          data
        }, (err, res) => {
          log("handleSendEmail", err, res)
          if (!err && res && res.data) {
            message.success("Email sent successfully")
            if (res.data.trackingId) {
              startPageLoading("Template loading")
              if (timerRef.current)
                clearTimeout(timerRef.current)
              timerRef.current = setTimeout(() => fetchTemplate({ trackId: res.data.trackingId }), WAITING_TIME)
            } else {
              stopPageLoading()
              // clearFormData()
              setResponse({
                responseMode: res.data.responseMode,
                processingStatus: res.data.processingStatus,
                endTemplate: res.data.endTemplate
              })
            }
          } else
            stopPageLoading()
        })
      } else
        message.warning("Please Enter a valid email address")
    } else
      message.warning("All filelds are require")
  }

  const clearFormData = () => {
    setFormData(initialFormState)
    setTrackId(undefined)
    setResponse({})
  }

  const handleTrackIdChange = (value, option) => {
    setTrackId(value)
    if (value === undefined) {
      setFormData(initialFormState)
    } else if (option.props.data) {
      setFormData(option.props.data)
    }
  }

  return (
    <div className={`ori-bg-white ${is_mobile ? "" : "ori-full-parent-height ori-flex-column"}`}>
      <Row className={`${is_mobile ? "" : "ori-full-flex ori-overflow-auto"}`}>
        <Col
          xs={24}
          md={12}
          className={`ori-pad-15 ${is_mobile ? "ori-b-border-light" : "ori-r-border-light ori-full-parent-height ori-overflow-auto"}`}
        >
          <div className="ori-b-pad-15 ori-b-mrgn-10 ori-b-border-light ori-flex-row ori-flex-jsb">
            Customer Mail
            <Select
              size="small"
              placeholder="Choose tracking info"
              style={{
                width: "300px",
                marginLeft: "10px"
              }}
              value={trackId}
              onChange={handleTrackIdChange}
              allowClear
            >
              {
                trackIdOptions.map((t, i) => (
                  <Select.Option
                    key={i}
                    value={t.value}
                    data={t.data}
                  >
                    {t.label}
                  </Select.Option>
                ))
              }
            </Select>
          </div>
          <InputItem
            title="To"
            type="email"
            placeholder="Enter email"
            name="to"
            value={formData.to}
            onChange={handleFormChange}
            disabled
          />
          <InputItem
            title="From"
            type="email"
            placeholder="Enter email"
            name="from"
            value={formData.from}
            onChange={handleFormChange}
          />
          <InputItem
            title="Subject"
            placeholder="Enter subject"
            name="subject"
            value={formData.subject}
            onChange={handleFormChange}
          />
          <TextareaItem
            title="Body"
            placeholder="Enter content here..."
            min_rows={10}
            max_rows={16}
            name="content"
            value={formData.content}
            onChange={handleFormChange}
          />
          <div className="ori-t-mrgn-20 ori-b-mrgn-10 ori-flex-row ori-flex-jc">
            <Button
              className="ori-r-mrgn-15"
              onClick={clearFormData}
            >
              Reset
            </Button>
            <Button
              type="primary"
              onClick={handleSendEmail}
            >
              Send
            </Button>
          </div>
        </Col>
        <Col
          xs={24}
          md={12}
          className={`ori-pad-15 ${is_mobile ? "" : "ori-full-parent-height ori-overflow-auto"}`}
        >
          <div className="ori-b-pad-15 ori-b-mrgn-10 ori-b-border-light">
            <span className="ori-r-mrgn-15">Bot Response</span>
            {
              response.responseMode &&
              <Tag>{response.responseMode}</Tag>
            }
            {
              response.processingStatus &&
              <Tag>{response.processingStatus}</Tag>
            }
          </div>
          {
            response.endTemplate &&
            <Input.TextArea
              className="ori-font-default"
              value={response.endTemplate}
              autosize
              disabled
            />
          }
        </Col>
      </Row >
    </div >
  )
}

const mapStateToProps = state => {
  return {
    is_mobile: getIsMobile(state),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      pageChanged,
      startPageLoading,
      stopPageLoading
    }, dispatch)
  }
}

EmailSendBox.propTypes = {
  actions: PropTypes.object,
  is_mobile: PropTypes.bool
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailSendBox);


// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/emailsendbox/index.js